import { Company, ProviderSettings } from '../../interfaces/company.interface';
import {
  DOC_TYPE_AADE_CODE_VALUES,
  INVOICE_AADE_CODES,
  RECEIPT_AADE_CODES,
} from '../../interfaces/documentType.interface';
import { InvoiceInterface } from '../../interfaces/invoice.interface';

export const isProviderEnabledForDoc = (
  provider: ProviderSettings | null | undefined,
  docType: Partial<DOC_TYPE_AADE_CODE_VALUES>,
) => {
  if (provider?.invoice?.enabled && INVOICE_AADE_CODES.includes(docType)) {
    return true;
  }

  if (provider?.receipt?.enabled && RECEIPT_AADE_CODES.includes(docType)) {
    return true;
  }

  /**
   * Inverted Delivery Note is not implemented from Viva
   * Awaiting feature to enable that
   * Tracked here: https://temeteron94.atlassian.net/browse/BIL-1874
   */
  // if (isDocTypeDeliveryNote(docType)) {
  //   return true;
  // }

  return false;
};

/**
 * @deprecated
 */
export const isDocumentAwaitingPosPayment = (entity: InvoiceInterface) => {
  if (!entity?.mark && entity?.paymentRecords?.length) {
    return !!entity?.paymentRecords?.[0]?.data;
  }

  return false;
};

export const isProviderEnabledForCompany = (company: Company | null) => {
  return !!(company?.settings?.provider?.invoice?.enabled || company?.settings?.provider?.receipt?.enabled);
};
